export const actualStreetNameCheck = (streetName: string) => {
    const streetAlternativePrefixCollection = ["ul.", "al.", "pl.", "os.", "plac", "aleja", "osiedle"];
    /*
     return a flag informing weather the street is filled with real street name. In cases of village (wieś) street field is duplicated with region name.
     In order to differentiate it we show street name only when it starts with one of the words from alternative street describing collection.
     */
    return streetAlternativePrefixCollection.some((prefix) => streetName.includes(prefix));
};
export const actualStreetNameCheck = (streetName: string) => {
    const streetAlternativePrefixCollection = ["ul.", "al.", "pl.", "os.", "plac", "aleja", "osiedle"];
    /*
     return a flag informing weather the street is filled with real street name. In cases of village (wieś) street field is duplicated with region name.
     In order to differentiate it we show street name only when it starts with one of the words from alternative street describing collection.
     */
    return streetAlternativePrefixCollection.some((prefix) => streetName.includes(prefix));
};
